






















































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'

@Component
export default class ComponentDesfazerIntegracao extends Vue {
  loadDesfazerIntegracao: boolean = false

  get modalDesfazerIntegracao() { return this.getFinanceiroStore.modal.desfazerIntegracao }
  set modalDesfazerIntegracao(value: boolean) { this.getFinanceiroStore.setModal({ name: 'desfazerIntegracao', value }) }

  get loadingDesfazerIntegracao() { return this.loadDesfazerIntegracao }
  set loadingDesfazerIntegracao(value: boolean) { this.loadDesfazerIntegracao = value }

  async desfazerIntegracao() {
    this.loadingDesfazerIntegracao = true
    const response: any = await this.getFinanceiroStore.desfazerIntegracao()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'A integração foi desfeita com sucesso!', icon: 'done', color: '#2E7D32' })
      this.modalDesfazerIntegracao = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao desfazer a integração.', icon: 'warning', color: '#C62828' })
    }
    this.loadingDesfazerIntegracao = false
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }
}
